import React from 'react';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

function DataReadOnlyBanner() {
  const { user, isDataReadOnly } = useAuth();

  if (!isDataReadOnly || !user?.dataCompleteAt) {
    return null;
  }

  const completedDate = new Date(user.dataCompleteAt).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <Alert variant="warning" className="mb-3 py-2">
      <strong>Read-only mode.</strong> You confirmed your data was complete on {completedDate}.
      Editing and imports are disabled for your account.
    </Alert>
  );
}

export default DataReadOnlyBanner;
